import { ReactNode } from 'react';
import cn from 'classnames';
import './Box.styles.css';

type Props = {
    className?: string;
    children: ReactNode;
};

export const Box = ({ className, children }: Props) => {
    return <div className={cn('boxWrap', className)}>{children}</div>;
};
